var _polygon, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cppTitle"
  }, "C++") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "cppTitle"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "60,8 104,34 104,86 60,112 16,86 16,34",
    fill: "#00599c"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 69,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 34,
    fill: "#ffffff"
  }, "C")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 61,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#ffffff"
  }, "+")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 83,
    y: 76,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#ffffff"
  }, "+")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpp);
export default __webpack_public_path__ + "static/media/cpp.658e8d8dceecbb7c10a2e11379b2424b.svg";
export { ForwardRef as ReactComponent };